import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';

import { Script } from '../../../techstyle-shared/react-marketing';

export default function KlarnaSnippet({ onReady }) {
  const klarnaScript = config.get('public.klarna.checkoutScript');
  const clientId = config.get('public.klarna.clientId');
  const environment = config.get('public.klarna.environment');

  return (
    <>
      <Script
        async
        src={klarnaScript}
        data-environment={environment}
        data-client-id={clientId}
        globalScriptKey="klarna-widget-checkout"
        onReady={onReady}
        charset="utf-8"
      />
    </>
  );
}

KlarnaSnippet.propTypes = {
  onReady: PropTypes.func.isRequired,
};
